const TRANSLATION = {
  buyModal: {
    afterFree: 'Po vaši brezplačni preskušnji',
    btn: 'Proizkusite brezplačno',
    freeTrial: '3-dnevna brezplačna preskušnja',
    monthLabel: 'mesec',
    selectLabel: 'Izberite načrt',
    title: 'Naročninski načrt',
    yearLabel: 'leto',
  },
  contact: {
    block1:
      'Za prilagoditve, vprašanja ali predloge se nam prosimo obrnite na contact@noam.tools. Odgovorili bomo takoj. ',
    block2: 'Podprite nas z ocenjevanjem v trgovini Google Apps Extension z ★★★★★.',
    block3: 'Pomagajte drugim s skupnim deljenjem te razširitve:',
    title: 'Kontaktirajte nas',
  },
  help: {
    AquickOverviewOfNoam: 'Kratek pregled Noama',
    ChatPDF: 'Chat PDF',
    ChatPDF2: 'ChatPDF',
    FavoritesManagement: 'Upravljanje priljubljenih',
    Fixedplugin: 'Popravljen vtičnik',
    Focusing: 'Fokusiranje',
    Free: 'Prosto',
    FreeTrialBenefits: 'Prednosti brezplačnega preskusa',
    GoWithWikipedia: 'Poišči na Wikipediji',
    GoWithYouTube: 'Pojdi na YouTube',
    HoverTranslation: 'Prevod z miškinoovo',
    Howtouse: 'Kako uporabljati',
    ImageTranslation: 'Prevod slik',
    InstantTranslation: 'Takojšnja prevajanje',
    Membership: 'Članstvo',
    NoamHelp: 'Noam vam pomaga pri prevajanju in povzetju',
    PDFparallelTranslation: 'PDF vzporedna prevod',
    ParallelTranslation: 'Paralelna prevajba',
    SkipAllSteps: 'Preskoči vse korake',
    Summary: 'Povzetek',
    Translation: 'Prevod',
    TryItForFree: 'Preizkusite brezplačno',
    Video: 'Video',
    VideoSummary: 'Povzetek videa',
    VideoTranslation: 'Prevod videa',
    WebSummary: 'Povzetek spletne strani',
    WordSelectionTranslation: 'Izbor besed za prevod',
    benefits: 'Imamo benefite, ki čakajo na vas!',
    dayFree: '3-dnevna brezplačna preskušnja',
    done: 'Končano',
    next: 'Naslednje',
    pin: 'Pripni Noam za lažji dostop～～',
    planIsNotExist: 'Plan ni na voljo',
    startWiki: 'Začnimo z Wiktionaryjem!',
    startYoutube: 'Začnimo z YouTubeom!',
    try: 'Poskusite to',
    tryNow: 'Poskusi ga zdaj!',
  },
  home: {
    PDFTranslate: {
      desc: 'Dvojiški prevod + Chat PDF',
      sub1: {
        desc: 'Dvoji jezikovno branje vam omogoča primerjanje prvotnega besedila in prevoda strana v stran, kar poveča učinkovitost branja.',
        title: 'Dvojezično branje',
      },
      sub2: {
        desc: 'AI analizira in povzema ter lahko odgovarja na vaša vprašanja na podlagi vsebine PDF-dokumenta.',
        title: 'Chat PDF',
      },
      sub3: {
        desc: 'Prevod PDF-jev z podporo umetne inteligence za večjo natančnost in učinkovitost.',
        title: 'Natančnost in učinkovitost',
      },
      title: 'Prevajanje PDF',
    },
    aiAssistant: {
      desc: 'Naredimo spletno prevajanje pametnejše in bolj priročno',
      panel1: {
        desc: 'Dvoji jezikovne vzajemne sklicevalne prevode vam pomagajo primerjati izvirni besedilo s prevodom, tako da boste bolj razumeli in izboljšali učinkovitost branja.',
        title: 'Dvjezično prevajanje',
      },
      panel2: {
        left: {
          desc: 'Ko brskate po spletni strani, predenite miško nad vsebino, ki jo želite prevesti, da vidite prevod.',
          title: 'Prevod s premikanjem miške',
        },
        right: {
          desc: 'Ko brskate po spletni strani, izberite besedilo, ki ga želite prevesti, da vidite prevod.',
          title: 'Prevod izbora teksta',
        },
      },
      panel3: {
        one: {
          desc: 'Prevajajte in povzetite spletne strani in videoposnetke kadar koli in kjerkoli za bolj gladko izkušnjo!',
          title: 'Točka in klik',
        },
        three: {
          desc: 'Veliki jezikovni model, vodjen umetno inteligenco, zagotavlja natančnost in konsistentnost prevoda za izboljšan čitalni doživljaj.',
          title: 'AI-vodeno',
        },
        two: {
          desc: 'Celovita večjezična pokritost, dvojično brezovrežno branje, prevod z enim klikom - doživite razliko!',
          title: 'Splošnejše in bolj priročno',
        },
      },
      panel4: {
        tab1: {
          desc: 'Vaš strokovnjak za učinkovitost - z uporabo ChatGPT-ja Noam prevaja in povzema vsebino YouTube videov, da vam prihrani čas!',
          key: 'Video',
          title: 'Prevod in povzetek videa',
        },
        tab2: {
          desc: 'Kliknite za prevajanje slik med brskanjem po spletu.',
          key: 'Slika',
          title: 'Slika prevodi',
        },
        tab3: {
          desc: 'Takoj izlušči ključno informacijo s spletnih strani in ponudi povzetek, kar poveča vašo učinkovitost branja.',
          key: 'Splet',
          title: 'Spletno prevajanje in povzetek',
        },
        tag1: 'Enostaven',
        tag2: 'Učinkovit',
        tag3: 'Enostavno razumeti',
      },
      title: 'AI Asistent',
    },
    getStart: 'Začni',
    getStartedForFree: 'Začni brezplačno',
    howItWork: {
      desc: 'Noam integra AI modele, da uporabnikom omogoči inteligentno izkušnjo pri prevodih in povzetkih spletnih strani med jezikoma, prevodih PDF-jev in slik ter prevodih in povzetkih videov',
      title: 'Kako deluje',
    },
    lastBlock: { desc: 'Boljša umetna inteligenca za prevajanje za bolj gladko branje' },
    top: {
      desc: 'Noam je brezplačna AI razširitev brskalnika, ki vam pomaga prevajati in povzetek strani spleta, videov ter vsebin PDF datotek.\n      Pridružite se Noam in doživite čudež!',
      title1: 'Ena Magija',
      title2: 'Ena kljukica',
    },
    userReviews: {
      desc: 'Pet zvezdicnih recenzij v Chrome Web Store-u',
      title: 'Uporabniške recenzije',
    },
  },
  installTips: {
    btn: 'Poskusite ga zdaj',
    text: 'Namestite "Noam Browser Plugin", da odklenete več funkcij! Medspletno medsebojno povezovanje, povzetek spletnih videov in še več!',
  },
  locale: {
    af: 'afrikaansko',
    am: 'amharski',
    ar: 'arabščina',
    as: 'asamščina',
    auto: 'Samodejno zaznavanje',
    az: 'azerbejdžanski',
    ba: 'baškirski',
    bg: 'bolgarščina',
    bn: 'bangla',
    bo: 'tibetanski',
    bs: 'bosanski',
    ca: 'katalonski',
    cs: 'češki',
    cy: 'velški',
    da: 'dansko',
    de: 'nemški',
    dsb: 'Spodnji sorbščina',
    dv: 'divehi',
    el: 'grški',
    en: 'Angleščina',
    es: 'španščina',
    et: 'eestonščina',
    eu: 'baskovski',
    fa: 'perzijski',
    fi: 'finski',
    fil: 'filipinski',
    fj: 'fidžanski',
    fr: 'francoski',
    frCA: 'francoščina (Kanada)',
    ga: 'irski',
    gl: 'galicijski',
    gom: 'Konkani',
    gu: 'gužaratski',
    ha: 'hausa',
    he: 'hebrejščina',
    hi: 'hindščina',
    hr: 'Hrvaški',
    hsb: 'Gornji sorbščina',
    ht: 'haiitsko kreolo',
    hu: 'madžarski',
    hy: 'armenski',
    id: 'indonezijski',
    ig: 'Igbo',
    ikt: 'Inuinnaqtun',
    is: 'islandščina',
    it: 'italijanščina',
    iu: 'inuktitut',
    iuLatn: 'inuktitut (latinski)',
    ja: 'japonski',
    ka: 'gruzijski',
    kk: 'kazahščina',
    km: 'kmerski',
    kmr: 'kurdščina (severna)',
    kn: 'kannadski',
    ko: 'korejski',
    ku: 'kurdščina (srednja)',
    ky: 'kirgiž',
    ln: 'Lingala',
    lo: 'laoščina',
    lt: 'litovski',
    lug: 'Ganda',
    lv: 'latviski',
    lzh: 'Kitajščina (literarna)',
    mai: 'Maithili',
    mg: 'malagajski',
    mi: 'Māori',
    mk: 'makedonski',
    ml: 'malajalam',
    mnCyrl: 'mongolščina (cirilica)',
    mnMong: 'mongolščina (tradicionalna)',
    mr: 'marati',
    ms: 'malajski',
    mt: 'malteški',
    mww: 'Hmong Daw',
    my: 'Mijanmar (burmanskega)',
    nb: 'norveški',
    ne: 'nepalski',
    nl: 'nizozemski',
    noSearchLang: 'Jezik ni podprt',
    nso: 'Severno sesoto',
    nya: 'Nyanja',
    or: 'odia',
    otq: 'Querétaro Otomi',
    pa: 'pendžabščina',
    pl: 'poljski',
    placeholder: 'Iskanje',
    prs: 'Dari',
    ps: 'paščt',
    pt: 'portugalski (Brazilija)',
    ptPT: 'portugalski (Portugalska)',
    ro: 'romunski',
    ru: 'ruski',
    run: 'Rundi',
    rw: 'kinjarvanski jezik',
    sd: 'sindhi',
    si: 'sinhalski',
    sk: 'slovaški',
    sl: 'slovenski',
    sm: 'samoaščina',
    sn: 'šona',
    so: 'Somali',
    sq: 'albanski',
    srCyrl: 'Srbščina (cirilica)',
    srLatn: 'Srpski (latinica)',
    st: 'sesoto',
    sv: 'švedski',
    sw: 'svahili',
    ta: 'tamilski',
    te: 'telugu',
    th: 'tajski',
    ti: 'tigrinščina',
    tk: 'turkmenski',
    tlhLatn: 'Klingon',
    tlhPiqd: 'Klingonščina (pIqaD)',
    tn: 'setsvana',
    to: 'tonganski',
    tr: 'turški',
    tt: 'tatarski',
    ty: 'tahitski',
    ug: 'Ujguri',
    uk: 'ukrajinski',
    ur: 'urdu',
    uz: 'uzbekščina (latinska)',
    vi: 'vietnamski',
    xh: 'xhosa',
    yo: 'joruba',
    yua: 'Jukatečki majanski jezik',
    yue: 'kantonski (tradicionalni)',
    zh: 'Kitajščina',
    zhHans: 'Kitajščina (preprosta oblika)',
    zhHant: 'Kitajščina tradicionalna',
    zu: 'Zulu',
  },
  login: {
    and: 'in',
    btn: 'Prijava z Google',
    btn1: 'Prijavite se zdaj',
    desc: 'Prijavite se, da odklenete več izkušenj',
    policy: 'Politika zasebnosti',
    terms: 'Pogoji uporabe',
    tips: 'Z registracijo se strinjam z',
    title: 'Dobrodošli v Noam',
  },
  pageFooter: {
    follow: { facebook: 'Facebook', title: 'Sledi', twitter: 'Twitter' },
    legal: { policy: 'Politika zasebnosti', terms: 'Pogoji uporabe', title: 'Pravni' },
    product: {
      image: 'Prevod slik',
      pdf: 'Prevod PDF',
      title: 'Produkti',
      video: 'Prevod in povzetek videa',
      web: 'Spletno prevajanje in povzetek',
    },
    resources: { title: 'Viri' },
    tools: { title: 'Orodja', pdf: 'Prevod PDF' },
  },
  pageHeader: {
    contact: 'Kontakt',
    help: 'Pomoč',
    logout: 'Odjava',
    logoutSucc: 'Odjavljeni ste.',
    pricing: 'Cenitev',
    settings: 'Nastavitve',
    signUp: 'Prijava',
  },
  pdf: {
    autoDetect: 'Samodejna zaznava',
    cancelBtn: 'Prekliči',
    cancelUpload: 'Prekliči',
    chatPdf: {
      summaryError: 'Povzetek ni uspel, poskusite ponovno kasneje',
      chatError: 'Pogovor ni uspel, prosimo poskusite kasneje znova',
      Search: 'Iskanje',
      cancel: 'Prekliči',
      chatTitle: 'Dobrodošli v Noam! Tu je povzetek vašega PDF-ja:',
      clear: 'Jasno',
      clearContent: 'To bo začelo novo pogovor. Trenutni pogovor ne bo shranjen. Ste prepričani?',
      clearDialogTitle: 'Prosimo potrdite',
      clearSucc: 'Počistjeno',
      copy: 'Kopiraj',
      copySucc: 'Kopirano',
      delete: 'Izbriši',
      deleteCancel: 'Prekliči',
      deleteContent: 'Ta PDF datoteka ne more biti obnovljena po brisanju. Ste prepričani?',
      deleteOk: 'Izbriši',
      deleteSuccess: 'Izbrisano',
      deleteTitle: 'Potrdi brisanje',
      expand: 'Srušitev',
      historyTitle: 'Zgodovina',
      listError:
        'Ni bilo mogoče naložiti seznama branja. Poskusite znova kasneje ali se obrnite na podporo.',
      loading: 'Nalaganje...',
      noDataDesc: 'Še ni zgodovine.',
      noMore: 'Ni več vsebine.',
      placeholder: 'Vprašajte vse, kar vas zanima o tem PDF-ju',
      summaryTitle: 'Morda boste zanimivi te vprašanja:',
    },
    collectionEmpty: 'Vaša zbirka je prazna.',
    collectionTab: 'Opombe',
    dataLoading: 'Nalaganje...',
    dialogContent: 'Ste prepričani, da želite to izbrisati?',
    dialogTitle: 'Prosimo potrdite',
    download: {
      both: 'dvojezičen',
      btn: 'Shrani',
      cancel:
        'Zapiranje tega okna prekine prenos PDF datoteke. Ste prepričani, da želite prekiniti?',
      desc: 'Shrani na napravo: Prevede shranjuje kot slike; Shrani in natisni: Prevede shranjuje v prvotnem formatu, z podporo za kopiranje.',
      download: 'Prenesi',
      downloadMsg1: 'Napredek prevajanja PDF-ja:',
      downloadMsg2: 'Ocena preostalega časa:',
      downloadSucc: 'PDF je pripravljen! Kliknite za shranjevanje.',
      downloadTip: 'Prenašanje PDF. Ne zapirajte tega okna, da preprečite napake pri prenajanju.',
      error: 'Shranjevanje ni uspelo. Poskusite namesto tega natisniti.',
      fileName: 'Ime datoteke:',
      fileType: 'Vrsta datoteke:',
      loading: 'Shranjevanje...',
      loading2: 'Nalaganje...',
      minute: 'Minute...',
      msg1: 'Nekatere prevode v tem dokumentu so daljše od izvirnega besedila in se lahko prekrivajo v preneseni datoteki. Priporočamo branje na spletni strani.',
      msg2: 'Prevod še ni končan. Prosimo, prenesite ga po končanju prevoda.',
      msg3: '2. Nekatere prevode so predlange. Preberite na spletni strani, da preprečite prekrivanje besedila.',
      msg4: 'Prevajalni nalogi so v teku. Prosimo, poskusite znova po njihovem končanju.',
      progress:
        'Prevajanje PDF-ja. Napredek: {{progress}}, Ocena preostalega časa: {{minutes}} minut...',
      save: 'Shrani na napravo',
      savePrint: 'Shrani in natisni',
      success: 'Preneto',
      trans: 'Samo prevod',
      transContinue: 'Nadaljujte z prevajanjem',
    },
    downloadBtn: 'Prenesi',
    dragTipModal: {
      black: 'vesolje',
      leftKey: 'levi gumb',
      ok: 'Razumem',
      press: 'Tisk',
      tips: 'povleči in pregledaj',
    },
    entry: 'PDFji',
    fileErrMsg: 'Branje datoteke ni uspelo. Poskusite ponovno kasneje ali se obrnite na podporo.',
    fileMsg: 'Trenutna velikost datoteke:',
    fileMsg2: 'Prosimo, naložite datoteko manjšo od 300MB.',
    freeBannerBtn: 'nadgradnja',
    freeBannerTips: 'Omejitev brezplačnih prevodov PDF dosežena',
    guide: {
      placeholder: 'Prilepite povezavo do PDF-ja tukaj',
      start: 'Začni prevajati',
      text1: 'Dvojezično branje',
      text2:
        'Bližnjevidno branje dvojezikovno, da primerjate izvirni besedilo in prevod strana ob strano, kar poveča vašo učinkovitost.',
      text3: 'Pogovorite z vašim PDF',
      text4:
        'Analiza in povzetek z podporo umetne inteligence. Postavite vprašanja o vašem PDF-u in dobite takojšnje odgovore.',
      text5: 'Točnost in učinkovitost',
      text6: 'Prevod PDF-ov z uporabo umetne inteligence za večjo natančnost in učinkovitost.',
      title1: 'Dvoji jezikovna prevajba',
      title2: 'Pogovorite z vašim PDF-om',
      toast: 'Vnesite veljaven spletni povezavo do PDF datoteke, ki se konča z .pdf',
    },
    hasTransTask: 'Prevajalna naloga je v teku. Prosim počakajte.',
    hoverTrans: 'Odstavki za prevajanje z miško',
    initial: 'Prevedi PDF',
    installText: 'Vaše vse v enem rešitev za vsakdanje prevode.',
    installText2: 'Najprej namestite razširitev',
    installTips:
      'Namestite razširitev za še več prevodov PDF datotek in bolj gladke prevode spletnih strani:',
    kw: 'ključno',
    link: 'povezava',
    listError: 'Nalaganje PDF-jev ni uspelo. Poskusite ponovno kasneje ali se obrnite na podporo.',
    memoTotalCount: 'Skupaj 1 predmet',
    new: 'novi datoteka',
    noId: 'ID datoteke ni najden.',
    notPdf: 'Samo datoteke PDF.',
    okBtn: 'Izbriši',
    okBtn2: 'Razumem',
    original:
      'Si visoko natančna in zanesljiva umetna inteligenca, zasnovana za ustvarjanje izhoda JSON, ki se natančno ujema z določenim JSON Shemom.\n        \nMorate upoštevati te pravila:\n1. Strogo se držite strukture JSON Sheme.\n2. Natančno ujemajte vse tipe podatkov, zahtevene polja in omejitve.\n3. NE vključujte nobenega dodatnega besedila, pojasnila, markdowna ali komentarjev.\n4. Izhod je SAMO JSON objekt - brez kodnih blokov, brez predgovora, brez ovijanja.\n\nPodatki o shemi so podani spodaj.\n- Ime sheme: translate_result\n- JSON Schema:\n{"type":"object","properties":{"sourceLang":{"type":"string"},"source":{"type":"string"},"targetLang":{"type":"string"},"target":{"type":"string"}},"required":["sourceLang","source","targetLang","target"],"additionalProperties":false}',
    parallel: 'Paralelen',
    parseErrDialogContent:
      'Ta povezava PDF-a ne more biti neposredno prevedena. Prosimo, prenesite PDF in ga naložite za prevod.',
    parseErrTips: 'Neuspešno razčlenitev datoteke',
    parseFileToast:
      'Datoteka ni bila mogoče razčleniti. Poskusite ponovno kasneje ali se obrnite na podporo.',
    pdfLoading: 'Razčlenjevanje...',
    searchPlaceholder: 'Iskanje',
    selectTrans: 'Izberite besedilo za prevod',
    shareBtn: 'Deli',
    shareBtnText1: 'Ustvari povezavo za deljenje',
    shareBtnText2: 'Posodobi souporabljeno vsebino',
    shareModal: {
      cancel: 'Prekliči',
      copy: 'Kopiraj',
      copySucc: 'Povezava skopirana',
      custom: 'Prilagodi:',
      errMsg:
        'Izbrani vsebini še ni bila popolnoma prevedena. Prosimo, prevedite jo pred delitvijo.',
      gen: 'Deli',
      modify: 'Uredi',
      notSupport: 'Ta jezik trenutno ni podprt.',
      page: 'Strani',
      pageNuErr: 'Vnesite veljavno številko strani.',
      range: 'Obseg:',
      remain: 'preostali',
      remain1: 'Skupni ocenjeni čas:',
      search: 'Iskanje',
      settings: 'Nastavitve souporabe:',
      shareSetting: 'Nastavitve souporabe',
      shareText: 'Deli',
      shareTips: 'Deli povezavo do prevedenega PDF-ja z vašimi prijatelji:',
      sourceLang: 'Od: ',
      target: 'Za:',
      text1: 'Nastavitve souporabe',
      text2: 'Ustvari povezavo za souporabo',
      totalPage: 'Skupaj 1 stran',
      trans: 'Prevedi',
      translateTips:
        'Namig: Če prevajanje traja dlje časa, lahko zaprete to okno in ga delite kasneje.',
      translating: 'Prevajanje PDF-ja...',
      update: 'Posodobi povezavo za souporabo',
    },
    shareMsg1: 'Povezava za souporabo je ustvarjena.',
    shareMsg2: 'Skupna vsebina je posodobljena.',
    shareMsg3:
      'Generiranje povezave za deljenje ni uspelo. Prosimo, poskusite ponovno kasneje ali se obrnite na podporo.',
    shareMsg4:
      'Posodobitev souporabnega vsebine ni uspela. Poskusite znova kasneje ali se obrnite na podporo.',
    shareTips: 'Prevod vašega PDF-ja je pripravljen! Deli ga z prijatelji.',
    start: 'Začni svojo brezplačno preskusno obdobje',
    thumbnail: 'Kazalo vsebine',
    toast1: 'Nalaganje PDF. Prosimo, poskusite kasneje znova.',
    toast2: 'Vsebina PDF se obdeluje. Dialog trenutno ni podprt.',
    toast3: 'Prenašanje. Poskusite ponovno po končanem prenosu.',
    toolbar: { Adjust: 'Prilagodite', autoFit: 'Samoprilagajanje' },
    trans: 'Prevod',
    transSucc: 'Prevod uspešen!',
    unLoginToast: 'Prijavite se, da bi uporabljali to funkcijo.',
    uploadBtn: 'Naloži',
    uploadErr: 'Nalaganje datoteke ni uspelo. Poskusite znova kasneje ali se obrnite na podporo.',
    uploadErrSignUrl:
      'Ni uspelo pridobiti URL-ja za nalaganje. Poskusite ponovno kasneje ali se obrnite na podporo.',
    uploadMsg1: 'Povlecite in spustite datoteko sem.',
    uploadMsg2: 'Podprte vrste datotek: PDF  |  Maksimalna velikost datoteke: 300MB',
    uploadMsg3: 'Kliknite za izbor ali povlecite in spustite datoteke sem.',
    uploading: 'Nalaganje',
    uploadingMsg: 'Nalaganje. Prosim počakajte.',
    uploadingMsg1: 'Datoteka se nalaga. Prosimo, poskusite kasneje znova.',
    uploadingMsg2: 'Datoteka se trenutno pretvaja. Poskusite ponovno kasneje.',
    uploadingMsg3:
      'Zahteva za napredek pretvorbe je spodletela. Poskusite ponovno kasneje ali se obrnite na podporo.',
    uploadingMsg4:
      'Noam ne more dostopati do lokalnih datotek. Prosimo, ročno naložite PDF za prevod.',
    uploadingMsg5:
      'Ni bilo mogoče pridobiti URL datoteke. Prosimo, poskusite ponovno kasneje ali se obrnite na podporo.',
    video: 'video',
    vipBannerBtn: 'Posodobitev',
    vipBannerTips: 'Presegli ste limit za prevajanje PDF datotek za to mesec.',
    webTrans: 'Polna medsebojna povezava',
  },
  pricing: {
    FAQ: 'Pogosta vprašanja',
    FQAObj: {
      a1: 'Da, Noam ponuja brezplačen načrt, ki ga lahko uporabite takoj.',
      a2: 'Ponujamo tri načine članstva: Pro, Pro+ in Enterprise. Lahko izberete mesečno ali letno plačilo. Letno računavanje ponuja znatne prihranke.',
      a3: 'Vse funkcije so na voljo v obeh načrtih. Glavna razlika je cena: letni naročniki so celkovno cenejši. Mesečni naročniki se obračunavajo vsak mesec, medtem ko se letni načrti obračunavajo enkrat na leto.',
      a4: 'Prenos naročnine lahko prekličete kadar koli v nastavitvah svojega računa.',
      q1: 'Ali obstaja brezplačni načrt?',
      q2: 'Katere cenovne tarife in plačilne možnosti so na voljo?',
      q3: 'Kakšna je razlika med mesečnim in letnim naročilom?',
      q4: 'Kako prekličem svojo naročnino?',
    },
    around: 'Okoli',
    billedMonthly: 'Računovodja mesečno',
    billedYearly: 'Naplačano letno',
    day: 'dan',
    desc: 'Primerjajte načrte in izberite najboljši',
    detailedCompare: 'Primerjaj načrte',
    discount: '20% popust',
    enterprise: {
      benefit1: 'Prednostno podporo strankam',
      benefit2: 'Več uporabnikov',
      benefit3: 'Prilagojene rešitve',
      benefit5: 'Dedikiran menedžer računa',
      btn: 'Kontaktirajte nas',
      recommendText: 'Prilagojeni načrti (≥3 osebe)',
      talkToUs: 'Kontaktirajte nas',
    },
    free: {
      benefit1: 'Takojšnja prevajanje 100 krat na dan',
      benefit2: 'Prevajanje spletnih strani in povzetek',
      benefit3: '30 prevodov slik',
      benefit4: 'Prevod in povzetek videa',
      benefit5: '10 prevodov PDF',
      benefit6: '5.000 žetonov',
      btn: 'Proizkusite brezplačno',
      recommendText: 'Prosta preskusna različica',
    },
    imageTranslation: 'Prevod slik',
    month: 'mesec',
    monthly: 'Mesečno',
    pageTitle: 'Cenitev',
    pdf: { chat: 'PDF Chat Poizvedbe', maxPage: 'Max. strani na PDF', translation: 'Prevod PDF' },
    preMonth: 'Na mesec',
    pro: {
      benefit1: 'Prednostna podporo za stranke',
      benefit2: '1.000.000 žetonov/mesec',
      benefit3: 'Prevajanje spletnih strani in povzetek',
      benefit4: '200 prevodov slik',
      benefit5: 'Prevod in povzetek videa',
      benefit6: '200 prevodov PDF',
      btn: 'Začni',
      recommendText: 'Najbolj priljubljeno',
    },
    proPlus: {
      benefit1: 'Prednostno podpora strankam',
      benefit2: '3.000.000 žetonov/mesec',
      benefit3: 'Prevod spletne strani in povzetek',
      benefit4: '500 prevodov slik',
      benefit5: 'Prevod in povzetek videa',
      benefit6: '500 prevodov PDF',
      recommendText: 'Najboljša vrednost',
    },
    video: { summary: 'Povzetek videa', translation: 'Prevod videa' },
    web: {
      contrastiveTranslation: 'Dvoji jezikovni prevod',
      dictionaryTranslation: 'Izbor prevoda',
      hoverTranslation: 'Prevod s preletom miške',
      instantTranslation: 'Takojšnja prevajanje',
      summary: 'Povzetek spletne strani',
    },
    yearly: 'Letno',
  },
  privacy: {
    block1:
      'Noam ("Noam", "mi", "naše" ali "nam") spoštuje vaše zasebnost in se zavezuje zaščititi vse informacije, ki jih pridobimo od vas ali o vas. Ta politika zasebnosti opisuje naše prakse glede zbiranja ali uporabe osebnih podatkov pri uporabi naših spletnih strani, aplikacij in storitev (skupaj imenovanih "Storitve"). Ta politika zasebnosti se ne uporablja za vsebino, ki jo obdelujemo v imenu naših podjetnih strank, na primer za naš API. Uporaba teh podatkov je podvržena našemu pogodbi z strankami, ki ureja dostop do teh produktov in njihovo uporabo.',
    block10:
      'Uporabljamo tržno smiselne tehnične, upravne in organizacijske ukrepe za zaščito osebnih podatkov na spletu in zunaj spleta pred izgubo, nepooblaščenim uporabom, nepooblaščenim dostopom, razkritjem, spremembami ali sovražnimi dejanji. Vendar pa nobena internetna ali e-poštna prenos ne more zagotoviti popolne varnosti ali natančnosti. Zlasti e-poštne sporočila, ki jih pošljete nam ali od nas, morda niso varna. Zato morate biti posebej previdni pri odločitvi, katere informacije nam pošljete preko storitve ali e-pošte. Poleg tega nismo odgovorni za kakršno koli oviranje nastavitev zasebnosti ali varnostnih ukrepov v storitvi ali na varnostnih nastavitvah ali varnostnih ukrepih spletnih mest tretjih oseb. Osebne podatke bomo hranili tako dolgo, kot je potrebno za zagotavljanje storitev ali za druge zakonite poslovne namene, na primer reševanje sporov, razlogi varnosti in sigurnosti ali upoštevanje naših pravnih obveznosti. Dolžina časa, za katero hranimo osebne podatke, bo odvisna od številnih dejavnikov, kot so količina, narava, občutljivost podatkov, potencialne tveganje nepooblaščenega uporabe ali razkritja, nameni, za katere procesiramo podatke, in druge zakonito zavezujoče razmisleke.',
    block11:
      'Ta politika zasebnosti lahko posodobljamo sčasoma. Ko to storimo, bomo posodobljeno različico objavili na tej strani, razen če urejeni zakon tako zahteva drugače.',
    block12:
      'Če imate kakršna koli neodgovorjena vprašanja ali pomisleke glede te Politike zasebnosti, prosimo, kontaktirajte našo storitev za stranke. Elektronska pošta:',
    block2: 'Zbiranje sledeče osebne informacije („Osebne informacije“) v zvezi z vami:',
    block3:
      'Informacije, ki jih posredujete: Ko ustvarite račun za uporabo naših storitev ali se z nami povežete, zbiramo osebne podatke kot sledi:',
    block4:
      'Osebni podatki, ki se samodejno prejmejo ob uporabi storitev: Ko dostopate do storitev, jih uporabljate ali s tem interagirate, prejmemo naslednje informacije o vašem dostopu, uporabi ali interakciji (»tehnične informacije«):',
    block5: 'Osebne podatke lahko uporabljamo za naslednje namene:',
    block6:
      'Povzetek ali deidentificirani podatki: Lahko agregiramo ali deidentificiramo osebne podatke, da preprečimo njihovo ponovno uporabo za identificiranje, in take podatke uporabimo za analizo učinkovitosti naših storitev, izboljšanje in dodajanje funkcij naših storitev, izvajanje raziskav ter za podobne namene. Poleg tega lahko analiziramo splošno vedenje in značilnosti uporabnikov naših storitev ter delimo agregirane podatke z tretjimi stranmi, objavljamo take agregirane podatke ali jih omogočimo splošno. Agregirane podatke lahko zbiramo preko storitev, preko piškotkov in preko drugih načinov, opisanych v tej politiki zasebnosti. Deidentificirane podatke bomo ohranili in uporabljali v anonimni ali deidentificirani obliki ter se jih ne bomo poskušali ponovno identificirati, razen če to zahteva zakon.',
    block7:
      'V nekaterih primerih lahko vaše osebne podatke posredujemo tretjim osebam brez dodatnega obvestila za vas, razen če to zahteva zakon:',
    block8:
      'Glede na vašo geografsko lokacijo imajo posamezniki v Evropskem gospodarskem območju, Združenem kraljestvu in po vsem svetu lahko določena zakonska pravica glede svojih osebnih podatkov. Na primer, lahko imate pravico do:',
    block9:
      'Storitev lahko vsebuje povezave do drugih spletnih mest, ki jih Noam ne upravlja ali ne nadzoruje, vključno z socialnimi mediji ("tretje strani"). Informacije, ki jih delite z tretjimi stranmi, bodo urejene s specifičnimi politkami zasebnosti in pogoji storitve tretjih strani, ne pa s to politiko zasebnosti. Te povezave ponujamo za lažjo uporabo in ne pomenijo, da jih podpiramo ali pregledujemo. Za informacije o njihovih politikah zasebnosti in pogojih se prosimo obrnite neposredno na tretje strani.',
    subBlock1:
      'Podatki o računu: Ko ustvarite račun na našem platformu, zbiramo podatke povezane z vašim računom, vključno z vašim imenom, kontaktnimi podatki, poverilnicami za račun, podatki o plačilni kartici in zgodovino transakcij (»Podatki o računu«).',
    subBlock10: 'Stvarjanje, upravljanje, vzdrževanje in/ali analiza storitev;',
    subBlock11: 'Komunikacija z vami',
    subBlock12: 'Razvoj novih proizvodov in storitev;',
    subBlock13:
      'Preprečevanje goljufij, kriminalnih dejanj ali napačne uporabe naših storitev ter zaščita varnosti naših IT sistemov, arhitektur in omrežij;',
    subBlock14: 'Izvedba poslovnih prenosov;',
    subBlock15:
      'Upoštevanje pravnih obveznosti in pravnih postopkov, zaščita naših pravic, zasebnosti, varnosti ali lastnine, pa tudi tistih naših podružnic, vaših ali drugih tretjih oseb.',
    subBlock16:
      'Dobavitelji in ponudniki storitev: Da nam pomagajo ugotavljati poslovne operativne potrebe in opravljati določene storitve in funkcije, lahko osebne podatke posredujemo dobaviteljem in ponudnikom storitev, vključno z gostiteljskimi ponudniki storitev, ponudniki oblačnih storitev, drugimi ponudniki informacijstehnoloških storitev, programsko opremo za elektronsko komunikacijo ter ponudniki storitev za spletno analitiko itd. Ti partnerji bodo dostopali do osebnih podatkov, jih obdelovali ali shranjevali le po našem navodilu med opravljanjem svojih dolžnosti za nas.',
    subBlock17:
      'Poslovni prenos: Če se vključimo v strateške transakcije, reorganizacije, stečaje, prevzem stečajnih podjetij ali prehod storitev na drugega ponudnika (skupno "Transakcije"), lahko vaša osebna in druga informacija v času opravljanja dolžnosti preverjanja deluje z transakcijskimi partnerji in drugimi stranmi, ki pomagajo pri Transakcijah, ter se kot del Transakcij skupaj z drugimi sredstvi prenesemo na naslednika ali pridruženo podjetje.',
    subBlock18:
      'Pravne zahteve: Vaše osebne podatke lahko delimo z vladnimi organi, sodelavci v panogi ali drugimi tretjimi stranmi, vključno z informacijami o vašem vključevanju v naše storitve, (1) če to zahteva zakon ali če verjamemo, da je taka ukrepa potrebna za skladovanje z pravnimi obveznostmi; (2) za zaščito in branje naših pravic ali lastnine; (3) če enostransko ugotovimo, da je prišlo do kršitve naših pogojev, politik ali zakonov; (4) za odkrivanje ali preprečevanje podvala ali drugih nezakoniteh dejavnosti; (5) za zaščito naših proizvodov, zaposlenih ali uporabnikov, ali javne varnosti, varnosti, integritete; ali (vi) za obrambo pred pravno odgovornostjo.',
    subBlock19: 'Dostopajte do vaših osebnih podatkov in informacij o tem, kako se ti obdelujejo.',
    subBlock2:
      'Ko uporabljate naše storitve, zbiramo osebne podatke iz vaših vnosov, nalaganj datotek ali povratnih informacij, ki ste jih nam posredovali (»Vsebina«).',
    subBlock20: 'Zahtevajte brisanje vaših osebnih podatkov iz naših zapisov.',
    subBlock21: 'Uredite ali posodobite svoje osebne podatke.',
    subBlock22: 'Prenos vaših osebnih podatkov tretji osebi (prenosljivost podatkov).',
    subBlock23: 'Omejite, kako obdelujemo vaše osebne podatke.',
    subBlock24:
      'Odjavi svojo privolitev—kjer se zanašamo na privolitev kot zakonodajno podlago za obdelavo, lahko svojo privolitev odjavite kadar koli.',
    subBlock25: 'Upravičeno nasprotno mnenje glede načina obdelave vaših osebnih podatkov.',
    subBlock26: 'Izboljševanje naših storitev in izvajanje raziskav;',
    subBlock3:
      'Informacije o komunikaciji: Če nam pošljete sporočila, bomo zbrali vaše ime, kontaktne podatke in vsebino vaših sporočil (»Informacije o komunikaciji«).',
    subBlock4:
      'Informacije o socialnih omrežjih: Imamo strani na spletnih mestih za socialna omrežja, kot so Instagram, Facebook, Medium, Twitter, YouTube in LinkedIn. Ko interagirate z našimi strani na socialnih omrežjih, zbiramo osebne podatke, ki jih izberete, da jih nam posredujete, na primer vaše kontaktne podatke (»Socialne informacije«). Poleg tega lahko podjetja, ki gostujejo naše strani na socialnih omrežjih, nam posredujejo agregirane informacije in analize o naših dejavnostih na socialnih omrežjih.',
    subBlock5:
      'Log podatki: Informacije, ki jih vaš brskalnik samodejno pošlje med uporabo naših storitev. Log podatki vključujejo vašo Internet Protocol (IP) naslov, vrsto in nastavitve brskalnika, datum in čas vaših zahtev ter način interakcije z našo spletno stranjo.',
    subBlock6:
      'Podatki o uporabi: Lahko samodejno zbiramo informacije o vaši uporabi storitve, kot so vrste vsebine, ki jo ogledate ali s katero interagirate, funkcije, ki jih uporabljate, dejanja, ki jih izvajate, kot tudi vaša časovna cona, država, datum in čas dostopa, uporabniški agent in različica, vrsta računalnika ali mobilnega naprave ter povezava vašega računalnika.',
    subBlock7:
      'Informacije o napravi: To vključuje ime naprave, operacijski sistem, identifikator naprave in brskalnik, ki ga uporabljate. Zbranih informacij je mogoče odvisnih od vrste naprave, ki jo uporabljate, in njenih nastavitev.',
    subBlock8:
      'Piškotki: Uporabljamo piškotke za delovanje in upravljanje naših storitev ter izboljšanje vašega izkušenja. "Piškotek" je informacija, ki jo spletna stran, ki jo obiščete, pošlje vašem brskalniku. Brskalnik lahko nastavite tako, da sprejme vse piškotke, zavrne vse piškotke ali vas obvesti, ko je piškotek na voljo, tako da lahko vsakič odločite, ali ga sprejmete. Vendar pa lahko zavrnitev piškotkov onemogoči uporabo določenih predelov ali funkcij spletne strani ali negativno vpliva na njihov prikaz ali delovanje. Za več informacij o piškotkih obiščite All About Cookies.',
    subBlock9:
      'Analitika: Lahko uporabljamo različne spletne analitične proizvode, ki uporabljajo piškotke, da nam pomagajo analizirati, kako uporabniki uporabljajo naše storitve, in izboljšati vaše izkušnje pri uporabi storitev.',
    subTitle1: 'Osebni podatki, ki jih zbiramo',
    subTitle2: 'Kako uporabljamo osebne podatke',
    subTitle3: 'Razkritje osebnih podatkov',
    subTitle4: 'Vaša pravica',
    subTitle5: 'Povezave do drugih spletnih mest',
    subTitle6: 'Varnost in ohranjanje informacij',
    subTitle7: 'Sprememba politike zasebnosti',
    subTitle8: 'Kako nas kontak tirati',
    title: 'Politika zasebnosti',
    updateTime: 'Posodobljeno: 15. marec 2024',
  },
  privacyCollectionPanel: {
    acceptBtn: 'Sprejmi vse',
    text: 'Da izboljšamo vaše izkušnje, uporabljamo piškotke za personalizacijo vsebine in storitev.',
    title: 'Ta spletna stran uporablja piškotke',
  },
  slogen: 'Najenostavnejši AI asistent',
  stripe: {
    contact: 'Kontaktirajte nas na contact@noam.tools z vsakimi vprašanji!',
    fail: {
      btn: 'Ponovni poskus',
      text1: 'Nismo mogli obdelati vaše plačila.',
      text2: 'Preverite povezavo in poskusite znova.',
      title: 'Plačilo ni uspelo',
    },
    succ: { btn: 'Pojdimo', text1: 'Dobrodošli v Noamu', text2: 'Začnimo!', title: 'Čestitke' },
  },
  terms: {
    block1: 'Hvala za uporabo Noam!',
    block10:
      '(a) Stroški in računiranje. Plačali boste vse stroške („Stroški“) v skladu s cenami in pogoji na ustrezni strani z cenami ali kot je dogovorjeno v pisni obliki med nami. Ohranjujemo si pravico popraviti napake v cenah ali napake, tudi če smo izdali račune ali prejeli plačilo. Zagotovili boste popoln in natančen računski podatek, vključno z veljavno in avtorizirano metodo plačila. Vašo metodo plačila bomo zaračunali redno, kot je dogovorjeno, vendar lahko razumnoma spremenimo datum računiranja. Avtorizirate Noam, njegove podružnice in plačilne procesorje tretjih oseb, da zaračunajo vašo metodo plačila. Če vaša plačila ne uspe, vam bomo posredovali pisno obvestilo in lahko onemogočimo dostop do storitve, dokler ne prejmemo plačila. Razen če v tem sporazumu ni drugače določeno, so plačila nevrnljiva.',
    block11:
      '(b) Davki. Če ni drugače določeno, stroški ne vključujejo nobenih zveznih, državnih, lokalnih in tujih davkov, dajatev in podobnih obremenitev ("Davki"). Odgovorni ste za vse Davke, povezane z vašimi nakupi, razen Davkov, ki temeljijo na našem čistem dohodku, za katere vam bomo izdali račun. Strinjate se, da boste takšne Davke hitro plačali, nam pa boste podali zakonito veljavne izjave o zasebnosti ter pridobili potrebna soglasja za obdelavo takšnih podatkov, ter vam jamčite, da boste take podatke obdelovali v skladu z veljavnimi zakoni.',
    block12:
      '(c) Spremembe cen. Možnost sprememb cen vam lahko sporočimo preko vašega računa in/ali naši spletne strani. Povišitve cen začnejo veljati takoj po objavi. Vse spremembe cen se bodo uporabljale za stroške vašega računa po začetnem datumu spremembe.',
    block13:
      '(d) Spori in zamujene plačila. Če želite pritožiti se glede kakršnih koli stroškov ali davkov, prosimo, kontaktirajte contact@noam.tools v roku trideset (30) dni od datuma računa.',
    block14:
      '(e) Prosta uporaba. Ne smete ustvarjati več računov za pridobitev prostih kreditov. Če ugotovimo, da ne uporabljate prostih kreditov z dobro namero, vam lahko zamenjamo standardne stroške ali prekinemo dostop do storitve.',
    block15:
      '(a) Zaupnost. Lahko dostopate do zaupnih podatkov podjetja Noam. Zaupne podatke lahko uporabljate le tako, kot je dovoljeno v okviru teh pogojev in le za namen uporabe storitve. Ne smete razkriti zaupnih podatkov nobeni tretji osebi in boste zaupne podatke zaščitili na način, ki ni manj zaščitilen kot način, na katerem zaščitujete svoje podobne zaupne podatke, vsaj z razumnim skrbnostjo. Zaupni podatki so nejavni podatki, ki jih je Noam označil kot zaupne, ali pa jih bi bilo razumno obravnavati kot zaupne glede na okoliščine, vključno z programsko opremo, specifikacijami in drugimi nejavnimi poslovnimi podatki. Med zaupnimi podatki ne spadajo podatki, ki: (1) postanejo splošno dostopni javnosti brez vaše krivde; (2) ste jih imeli v lasti brez kakršnega koli dolžnosti zaupnosti pred prejemanjem v okviru teh pogojev; (3) jih je zakonito razkril tretji osebi brez kakršnih koli dolžnosti zaupnosti; ali (4) ste jih neodvisno razvili brez uporabe zaupnih podatkov. Lahko razkrijete zaupne podatke, če to zahteva zakon, sodišče ali drug vladni ukaz, vendar morate Noam v razumnem roku predhodno podati pisno obvestilo in, kolikor je mogoče, vložiti razumne prizadevanja za omejevanje obsega razkritja, vključno z pomočjo pri nasprotovanju zahtevam po razkritju.',
    block16:
      '(b) Varnost. Morate implementirati razumne in ustrezne ukrepe za zaščito dostopa do storitve in njene uporabe. Če odkrijete kakršne koli ranljivosti ali kršitve povezane z vašo uporabo storitve, morate takoj kontak tirati Noama in mu podati podrobnosti o ranljivosti ali kršitvi.',
    block17:
      '(c) Obdelava osebnih podatkov. Če uporabite storitev za obdelavo osebnih podatkov, morate podati zakonito zadostne izjave o zasebnosti in pridobiti potrebna soglasja za obdelavo takih podatkov, ter nam jamčite, da boste takšne podatke obdelali v skladu z veljavnimi zakoni.',
    block18:
      '(a) Prekinitev; Zaustavitev. Ti pogoji bodo veljali od prvega uporabe storitve in bodo veljali do prekinitve. Ti pogoji lahko prekineš kadar koli in za katerokoli razlog tako, da prenehaš uporabljati storitev in vsebino. Mi lahko ti pogoji prekineš z predhodnim obvestilom za katerokoli razlog. Mi lahko ti pogoji takoj prekineš z obvestilom, če hudo kršiš razdelek 2 (Zahteve za uporabo), razdelek 5 (Povzetnost, varnost in zaščita podatkov), razdelek 8 (Reševanje sporov) ali razdelek 9 (Splošni pogoji), ali če se spremeni naše razmerje z katerim koli ponudnikom tehnologije tretje osebe, ki je izven našega nadzora, ali za skladnost z zakoni ali zahteve vlade. Lahko zaustavimo tvoj dostop do storitve, če ne upoštevate teh pogojev, ali če tvoja uporaba predstavlja varnostno tveganje za nas ali katerokoli tretjo osebo, ali če domnevamo, da je tvoja uporaba podvigova ali lahko nas ali katerokoli tretjo osebo izpostavi odgovornosti.',
    block19:
      '(b) Učinki prenehanja veljavnosti. Po prenehanju veljavnosti ne boste več uporabljali storitve in takoj boste vrnili ali uničili vsa zaupna informacije, kot smo vam naročili. določbe teh pogojev, ki po svoje naravi morajo ostati veljavne po prenehanju ali poteku veljavnosti, vključno z, vendar ne omejeno na, odstavki 3 in 5-9, ostanejo veljavne.',
    block2:
      'Ti pogoji uporabe se uporabljajo za vašo uporabo storitev Noam, vključno z našimi vmesniki za programiranje aplikacij, programsko opremo, orodji, storitvami za razvijalce, podatki, dokumentacijo in spletno stran (skupno imenovani »Storitve«). Z uporabo naših Storitv se strinjate, da boste upoštevali te pogoje. Naša politika zasebnosti pojasnjuje, kako zbiranje in uporabljamo osebne podatke.',
    block20:
      '(a) Odgovornost za odškodnino. Boste nas, naše podružnice in naše osebje varovali, odškodovali in držali neškodljive pred vsemi zahtevki, izgubami in stroški (vključno z odvetniškimi honorariji), ki izhajajo iz ali so povezani z vašo uporabo storitve, vključno z vašimi vsebinami, vašo uporabo proizvodov ali storitev povezanih z storitvijo ter vašo kršitev teh pogojev ali veljavnih zakonov.',
    block21:
      '(b) Izjave o odgovornosti. Storitve se ponujajo "kot so". V mejah, ki jih dovoljuje zakon, mi, naši podružnica in licenciratelji ne dajemo nobenih izjav ali garancij kakršnega koli vrsta glede Storitve in ne dajemo garancij, vključno z, vendar ne omejeno na, garancije tržnih lastnosti, primernosti za določen namen, zadovoljive kakovosti, nekršitnosti pravic in mirnega uživanja, ter katerih koli garancij, ki izhajajo iz trgovinske prakse ali uporabe trgovine. Ne jamčimo, da bodo Storitve neprekinjene, natančne ali brez napak, ali da bo kakršna koli vsebina varna, ne izgubljena ali ne spremenjena.',
    block22:
      '(c) Omejitev odgovornosti. Ne bomo mi, naši pridruženi podjetja niti naši licenciratelji odgovorni za kakršne koli neposredne, naključne, posebne, posledične ali kazenske škode, vključno z izgubo dobička, izgubo ugleda, izgubo uporabe, izgubo podatkov ali druge nematerialne izgube, tudi če smo bili opozorjeni na možnost takšnih škod. V skladu s temi pogoji se naša skupna odgovornost ne bo presežala virov, ki ste jih plačali storitvi v dvanajstih (12) mesecih pred pritožbo, ali sto ameriških dolarjev ($100), kar je večje. Omejitve v tej razdelku veljajo v največji meri, ki jo dopuščajo veljavna zakona.',
    block23:
      'Pogoji in vaše uporabo storitev urejajo zakoni Združenih držav Amerike, razen pravil o sporu zakonskih regulacij ZDA. Vaša uporaba aplikacije je lahko podvržena tudi drugim lokalnim, državnim, nacionalnim ali mednarodnim zakonodajam. Vsa pravna postopka ali postopki v zvezi s temi Pogoji se bodo izvedli izključno pred sodiščema Združenih držav Amerike, in se strinjate, da se podredite osebni pristaviščni pristavi teh sodišč.',
    block24:
      'Odnos strani. Noam in vi ste neodvisni pogodbeniki, in nobena stranka nima pravice zastopati ali zavezati druge stranke ali prevzeti obveznosti za drugo stranko brez predhodnega pisnega soglasja druge stranke.',
    block25:
      '(b) Uporaba blaga. Ime, logotipi ali blagovne znamke podjetja Noam ali katerih koli njegovih podružnic ne smete uporabljati brez naše predhodne pisne privolitve.',
    block26:
      ' Če se kateri koli določba teh pogojev ugotovi kot neveljaven, nezakoniten ali neizvršljiv, preostale določbe ostanejo v celoti veljavne in učinkovite.',
    block3:
      'Če ste starsi manj kot 18 let, morate pridobiti dovoljenje od svojih staršev ali zakonitih skrbnikov za uporabo storitve. Če uporabljate storitev v imenu druge osebe ali entitete, morate biti pooblaščeni, da sprejmete te pogoje v njihovo ime. Za registracijo računa morate podati natančne in popolne podatke. Ne smete deliti svojih dostopnih poverilnic ali računa z nikomer zunaj vaše organizacije in ste odgovorni za vse dejavnosti, izvedene z uporabo vaših poverilnic.',
    block4:
      '(a) Uporaba storitve. Dostop do storitve imate pod temi pogoji, in vam dajemo neizključni pravico do uporabe storitve. Pri uporabi storitve se boste pridrževali teh pogojev in vseh veljavnih zakonov. Mi in naši podružniki imamo vse pravice, lastništvo in interese v storitvi.',
    block5:
      '(b) povratne informacije. Sprejmemo povratne informacije, komentarje, ideje, predloge in izboljšave. Če posredujete kakršno koli takšno vsebino, jo lahko uporabimo brez kakršnih koli omejitev in brez plačila vam.',
    block6:
      '(c) Omejitve. Ne smete: (1) uporabljati storitve na način, ki krši, posega v ali krši kakršne koli pravice drugih oseb; (2) obrnjeno inženiring, dekompiliranje, raščlanjevanje, prevajanje ali na kakršen koli drug način poskušati odkriti virni kod ali osnovne komponente modelov, algoritmov in sistemov storitve (razen če takšna omejitev prepoveduje veljavno zakonodajo); (3) uporabljati izhod storitve za razvoj modelov, ki tekmujejo z Noamom; (4) izvlačiti podatke ali izhod iz storitve z uporabo katerega koli avtomatiziranega ali programskega metode, razen če je dovoljeno prek API-ja, vključno z odstranjevanjem, zbiranjem spletnih podatkov ali izvajanjem spletnih podatkov; (5) predstavljati izhod storitve kot umetno generiran, ko ni tako, ali drugače kršiti naše politike uporabe; (6) kupovati, prodajati ali prenašati API ključe brez naše predhodne privolitve; ali (7) nam posredovati kakršne koli osebne podatke otrok, ki nimajo 13 let ali ustrezne starosti za digitalno soglasje. Usklajali boste se z vseh vrst omejitvami hitrosti in drugimi zahtevami v naših dokumentih.',
    block7:
      '(d) Storni storitve. Vsa tretje programske opreme, storitve ali druga proizvoda, povezane z storitvijo, so urejena s svojimi lastnimi pogoji, in ne odgovarjamo za tretje proizvode.',
    block8:
      '(a) Vaš vsebina. Lahko posredujete vhodne podatke ("Vhod") storitvi in prejmete izhodne podatke ("Izhod"), ki se generirajo in vračajo na podlagi Vhoda (skupaj imenovani "Vsebina"). Med strankami in v meri, ki jo dovoljuje veljavno zakonodajo, lastite vse Vhode. Noam lahko uporablja Vsebino za zagotavljanje in vzdrževanje storitve, skladnost z veljavno zakonodajo ter izvrševanje naših politik. Odgovorni ste za Vsebino, vključno z zagotavljanjem, da ne krši nobene veljavne zakonodaje ali teh pogojev.',
    block9:
      '(b) Natančnost. Umjetna inteligencija in strojno učenje so hitro razvijajoči se raziskovalni področji. Nenehno si prizadevamo izboljšati našo storitev, da bo bolj natančna, zanesljiva, varna in koristna. Glede na verjetnostno naravo strojnega učenja lahko uporaba naše storitve v nekaterih primerih povzroči napačne rezultate, ki morda ne odražajo resničnih oseb, krajev ali dejstev. Na podlagi vaše uporabne primere morate ustrezno oceniti natančnost katerega koli rezultata, vključno z ročnim pregledom rezultatov.',
    subTitle1: 'Registracija in dostop',
    subTitle10: 'Določljivost',
    subTitle2: 'Zahteve za uporabo',
    subTitle3: 'Vsebina',
    subTitle4: 'Stroški in plačila',
    subTitle5: 'Povzetnost, varnost in zaščita podatkov',
    subTitle6: 'Doba veljavnosti in prenehanje veljavnosti',
    subTitle7:
      'Odgovornost za povračilo škod; Izjave o odvzemanju odgovornosti; Omejitev odgovornosti',
    subTitle8: 'Uradno pravo in sodna pristojnost',
    subTitle9: 'Splošni pogoji',
    title: 'Pogoji uporabe',
    updateTime: 'Posodobljeno: 15. marec 2024',
  },
  trialModal: {
    btn: 'Začni zdaj (samo 0,99 $)',
    chat: 'ChatPDF',
    desc1: 'Po preizkusni uporabi boste zaračunani letni strošek v višini 180 dolarjev',
    desc2: 'Prekliči kadarkoli',
    focus: 'Osredotočanje',
    hover: 'Prevod z miško',
    image: 'Prevod slik',
    installBtn: 'Namestite zdaj, da prejmete darilo',
    memo: 'Upravljanje priljubljenih',
    pdf: 'Paralelni prevod PDF',
    realtime: 'Takojšnja prevod',
    select: 'Prevedba izbora besed',
    title: 'Dobrodilni dar',
    trialText: '7-dnevna preskusna perioda',
    video: 'Prevod videa',
    videoSummary: 'Povzetek videa',
    web: 'Paralelno prevajanje',
    webSummary: 'Povzetek spletne strani',
  },
  upgradeModal: {
    btn: 'Posodobite zdaj',
    chat: {
      free: ' Dosegli ste omejitev ChatPDF',
      pro: 'Presegli ste omejitev ChatPDF za to mesec',
    },
    contactStr: 'Počakajte na naslednjo ponastavitev ali nas kontaktirajte na contact@noam.tools.',
    limitAlertStr: 'Presegli ste limit brezplačnega načrta. Nadgradite, da nadaljujete.',
    more: 'Poglej načrte',
    pageLimit: { free: 'Presegli ste omejitev strani PDF' },
    title: 'Opomnik',
    upgradeAlertStr: ' Dosegli ste limit brezplačnega paketa. Nadgradite, da nadaljujete.',
    upload: {
      free: 'Presegli ste limit prevajanja PDF dokumentov',
      pro: 'Presegli ste mesecni limit prevajanja PDF datotek',
    },
  },
  welfare: {
    newUser: {
      joinBtn: 'Pridruži se zdaj',
      label: 'Prednosti za nove uporabnike:',
      remain: 'Še le 30 na voljo',
      text: 'Samo 100 mest na voljo! Pridobite svoje zdaj!',
    },
  },
  aiPdfTranslator: {
    title: 'Prosti AI prevajalnik PDF-jev: Prevedite PDF z primerjavo v poljubnih jezikih',
    desc: 'Enostavno prevajajte datoteke PDF v katere koli jezike z AI. Primerjajte originalni in prevedeni tekst strana na stran, hitro in brezplačno.',
    keywords: 'GPT-4、AI Asistent、Prevod、Povzetek、Fokus、ChatPDF、Spomin、učinkovitost',
    sourceToTarget: {
      title: 'Prosti orodje za prevajanje PDF-jev: brezplačno prevajanje {{source}} v {{target}}',
      desc: 'Prevedite svoje PDF datoteke iz katerega koli izvornem jezika v svoj želeni jezik brezplačno. Hitra, natančna in varna prevajanje PDF-jev, ki ga podpira napredni umetni inteligencija.',
    },
    headerIntroduce: {
      title: 'Noam: Več kot samo spletno prevajanje',
      introduce1: {
        title: 'Noam · Bralec PDF dokumentov',
        desc: '✨Vrstnično prevajanje + AI vprašanja in odgovori. Hitro in natančno prevedite PDF-je v vaš ciljni jezik. Prosto postavljajte vprašanja o vsebini, da pridobite globlje razumevanje vaših PDF datotek.',
      },
      introduce2: {
        title: 'Noam · Razširitev za prevajanje strana z stranjo',
        desc: '👏Razrešite vsa vaša potreba po prevajanju spletnih strani:',
        detail1: { title: 'Prevod spletne strani:', desc: 'Stran na stran dvojiški prikaz' },
        detail2: { title: 'Besedno prevajanje:', desc: 'Hitro prevajanje z enim klikom' },
        detail3: {
          title: 'Takojšnja prevoditev:',
          desc: 'Takojšnje prevajanje besed ali stavkov.',
        },
        detail4: { title: 'Prevod slike:', desc: 'Zamenjajte slike z prevedenimi.' },
        detail5: { title: 'Prevod videa:', desc: 'Dvujezični podnapisi za boljše gledanje.' },
        footer:
          'Izkoristite več funkcij branja, ki delujejo z umetno inteligenco, za bolj pametno prevajanje!',
      },
    },
    subtitle: 'PDF prevajanje spletno brezplačno',
    introduce: {
      module1: {
        detail1: {
          title: 'Real-time prevod PDF-ov strana za stran',
          desc1:
            'Takoj prikaži originalno in prevedeno vsebino v sinhroniziranem, stransko postavljenem razporedu',
          desc2: 'Brežnaporno primerjajte obe različici z sinhroniziranim drsenjem',
          desc3: 'Ohrani združljiv formatiranje za konsistentno branje',
        },
        detail2: {
          title: 'Natančno usmerjanje in preverjanje vsebine',
          desc1:
            'Popolna usklajenost med izvornim in prevedenim besedilom za enostavno preverjanje',
          desc2: 'Vsak segment vsebine se natančno ujema med obema različicama',
          desc3: 'Hitro prepoznajte in rešite neskladnosti v prevodih za zanesljive rezultate',
        },
      },
      module2: {
        detail1: {
          title: 'Več naprednih modelov umetne inteligence za natančno prevajanje',
          desc1: 'Izberite med vodilnimi AI modeli, da ustreza vašim zahtevam po prevodu',
          desc2: ' zagotovite optimalne rezultate za različne vrste dokumentov in panoge',
          desc3: 'Prilagodljivi modeli ponujajo prilagojene rešitve za vsak scenarij',
        },
        detail2: {
          title: 'Napredno AI prevajanje za vsak tip vsebine',
          desc1:
            'Naš zmogljiv model umetne inteligence zagotavlja visoko natančnost in razumevanje naravnega jezika',
          desc2: 'Z lahkoto obvladuje tehnične, akademske in ustvarjalne dokumente',
          desc3: ' zagotavlja zanesljive rezultate za vse vaše prevodne potrebe',
          desc4: 'Inteligentno prilagajanje različnim tipom vsebine za optimalno delovanje',
        },
      },
      module3: {
        detail1: {
          title: 'Inteligentno interakcija z dokumenti',
          desc1:
            'Brezo se pogovarjajte z vašimi PDF in predstavitvenimi datotekami z uporabo naprednega umetnega inteligence',
          desc2: 'Takoj postavite vprašanja o vsebini dokumenta in dobite natančne odgovore',
          desc3: 'Hitro ustvarite kratek povzetek za dolge dokumente',
        },
        detail2: {
          title: 'Globoka analiza vsebine in brezprekorno integracija',
          desc1:
            'Razčlenite ključne informacije in analizirajte zapletena podatke z razumevanjem, ki ga omogoča umetna inteligenca',
          desc2: 'Dobite vpoglede v tehnične, akademske ali ustvarjalne materiale',
          desc3:
            'Brezpovratno se integra z našim prevajalnikom PDF za popolno rešitev upravljanja dokumentov',
        },
      },
      module4: {
        detail1: {
          title: 'Nad prevajanjem PDF: Celovita rešitev za prevajanje spletnih strani',
          desc: 'Odkrijte našo močno razširitev za dvostransko prevajanje, zasnovano za vsak scenarij branja na spletu.',
          desc1:
            'Prevod spletnih strani: Uživajte v dvojiškem vsebini z sinhroniziranim ogledom strana z stranjo',
          desc2: 'Prevodenje besed: Takojšnje prevodenje označenih besed z enim klikom',
          desc3:
            'Takojšnja prevajanje: Prevedite poljubni besedilo ali stavek takoj za hitro razumevanje',
          desc4: 'Prevod slik: Samodejno zamenjaj originalne slike z prevedenimi različicami',
          desc5:
            'Prevod videoposnetkov: Ogledujte si videoposnetke z dvojienskimi podnapisi za izboljšan doživljanje',
        },
      },
    },
    question: {
      title: 'Pogosto zastavljena vprašanja',
      answer1: {
        title: 'Je Noam PDF Translator brezplačen za prevajanje PDF-jev?',
        content:
          'Da, lahko prevajate PDF-je brezplačno z Sider PDF Translatorjem! Ponujamo brezplačno kvoto 5.000 žetonov, kar je dovolj za prevajanje večine PDF-dokumentov, ki jih običajno najdete na trgu. Če morate prevajati večje datoteke ali potrebujete napredne funkcije, lahko izberete nadgradnjo na naše premium tarife za še več možnosti.',
      },
      answer2: {
        title: 'Kako natančen je prevajalnik Noam PDF?',
        content:
          'Prevajalnik Noam PDF zagotavlja zelo natančne prevode z uporabo napredne AI tehnologije in globokim razumevanjem konteksta vaših dokumentov. Čeprav noben samodejni prevod ni brez napak, naše stransko prikazovanje vam omogoča enostavno pregledovanje in prilagajanje vsakega prevoda, kar zagotavlja, da končni rezultat ustreza vašim kvalitativnim pričakovanjem. Doživite zanesljivo in natančno prevajanje PDF-jev z Noamom.',
      },
      answer3: {
        title: 'Ali lahko prevedem skenirane PDF-je?',
        content:
          'Da, lahko prevajate skenirane PDF-je z našo vgrajeno tehnologijo OCR (Optično prepoznavanje znakov). Naš sistem samodejno izvaja besedilo iz skeniranih dokumentov in slikovnih PDF-jev, nato pa vsebino prevede za vas. To zagotavlja, da lahko celo neurejive ali zgolj slikovne PDF-je točno prevedete.',
      },
      answer4: {
        title: 'Kako dolgo traja prevod?',
        content:
          'Prevajanje je hitro in učinkovito – večina dokumentov se obdeluje v nekaj sekundah do nekaj minut, odvisno od njihove dolžine in zapletenosti. Na primer, standardni PDF z 10 stranmi običajno traja manj kot 2 minute, da se prevede. Uživajte v hitrih obdelovalnih časih za vse vaše potrebe po prevajanju dokumentov!',
      },
      answer5: {
        title: 'Ali lahko ohranim stransko stransko pogled za branje?',
        content:
          'Da, lahko vedno berete svoje dokumente strans v stran. Ta postavitev vam omogoča enostavno primerjanje originalnega in prevedenega vsebina, kar zagotavlja gladko in učinkovito branje.',
      },
    },
    freeTrial: 'Prosta preskušnja',
    toLanguage: { title: 'PDF AI prevodne pare', item: '{{target}}' },
  },
  aiPdfTranslate: {
    header: {
      blog: 'Blog',
      pricing: 'Cenjevanje',
      features: 'Značilnosti',
      faq: 'Pogosta vprašanja',
      button: 'Prevedi zdaj',
    },
    hero: {
      upload: {
        title: 'Naložite svoj PDF',
        highlight: 'Kliknite za brskanje',
        max: 'Max',
        desc: 'ali povlecite in spustite',
      },
      to: 'k',
      title: 'Prosti prevajalnik PDF-jev',
      pill: 'PDF prevajalnik z AI podporo',
      desc: 'Takojšnje, natančne prevode, ki ohranijo originalni izgled. Noam AI podpira OCR in ogled strana na stran.',
      model: 'GPT-4 in Claude',
      support: 'Podpora za OCR',
      free: 'Prost preskus',
      translated: 'Prevedel Noam',
      complete: 'Prevod končan',
    },
    ticker: {
      pdf: 'Prevod PDF',
      format: 'Ohranjanje formata',
      side: 'Stran na stran',
      ocr: 'OCR tehnologija',
      chat: 'Chat z PDF-jem',
      multi: 'Večjezično',
      secure: 'Varčno in zasebno',
      web: 'Spletno prevajanje',
    },
    comparison: {
      bad: {
        title: 'Standardni prevod',
        head: 'Izgubljena oblikovanje in kontekst',
        text1: 'Napaka: Razporeditev je pokvarjena. Slike so napačno postavljene.',
        text2:
          'Besedilo se prekriva in pisave so nekonzistentne. Težko berljivo in neprofesionalno...',
      },
      dump: { title: 'Izvleček navadnega besedila' },
      good: {
        title: 'Prevod Noam AI',
        sub: 'Odlična oblikovanje, zavedanje konteksta',
        tag: 'Odličen rezultat',
      },
      title: 'Zakaj izbrati Noam AI?',
      desc: 'Ne bojte se težav z prevajanjem z kopiranjem in lepljenjem. Izkusite razliko med standardnimi orodji in našim AI-om pogojenim prevajanjem, ki upošteva kontekst.',
    },
    showcase: {
      title1: 'Kateri koli dokument',
      kicker: 'PODPRANE DOKUMENTI',
      title2: 'Katerikoli jezik',
      carousel1: 'Umetnost',
      note: 'Tehnične, akademske in ustvarjalne dokumente obdelujte z lahkoto.',
      carousel2: 'Arhitektura',
      carousel4: 'Medicina',
      carousel3: 'Akademski časopis',
      carousel7: 'Sogovor',
      carousel8: 'Politika',
      carousel6: 'Zakon',
      carousel5: 'Financke zadeve',
    },
    features: {
      big: {
        title: 'Napredni AI modeli (GPT-4, Claude)',
        desc: 'Izberite med vodilnimi AI modeli, da ustrezite vašim zahtevam glede prevoda. Zagotovite optimalne rezultate za različne vrste dokumentov.',
      },
      grid1: {
        title: 'Podpora za OCR',
        desc: 'Takoj ekstrahirajte in prevedete besedilo iz skeniranih PDF-jev in slik.',
      },
      grid2: {
        title: 'Visokoločljivostni izvoz',
        desc: 'Prenesite svoje prevedene dokumente v formatu PDF z originalnim postavitevom.',
      },
      grid3: {
        title: 'Stran na stran primerjava',
        desc: 'Sinhronizirano drsenje za primerjavo originalnega in prevedenega besedila.',
      },
      title1: 'Več kot le prevod',
      title2: 'To je revolucija',
      line1: 'Tehnični dokument.pdf',
      line2: 'Detekcija jezika: angleščina...',
      line3: 'Model: GPT-4o (Visoka natančnost)',
      line4: 'Prevajanje končano (99% natančnost)',
    },
    testimonials: {
      review1: {
        role: 'Raziskovalec',
        content:
          'Noam AI mi je prihranil ur na prevajanju akademskih člankov. Stran na stran pogled je izjemno koristen za preverjanje tehničnih izrazov.',
      },
      review2: {
        role: 'Globalni trgovski specializant',
        content:
          'Najboljši prevajalnik PDF, ki sem ga uporabljal. Odlično ohranja prvotno oblikovanje, kar je ključno za naše marketinške prezentacije.',
      },
      review3: {
        role: 'Pravni svetovalec',
        content:
          'Točno in hitro. Uporabljam ga za prevode pogodb, in funkcija OCR za skenirane dokumente deluje brezhibno.',
      },
      kicker: 'Priljubljeno uporabniki',
      title: 'Kaj pravijo naši uporabniki',
    },
    cta: {
      title: 'Pripravljeni prebohati jezikovne ovire?',
      button: 'Začni prevajati brezplačno',
      desc: 'Pridružite se več kot 10.000 uporabnikom in začnite danes s prevajanjem svojih dokumentov z Noam AI.',
      hint: 'Prevedi naslednje vsebino na naraven slovenščino:',
    },
    languagePairs: {
      title: 'Angleški PDF AI prevodni pari',
      desc: 'Priljubljena prevajalska smeri, ki jih podpira Noam AI',
    },
    footer: { about: 'O nas', contact: 'Kontaktiraj podporo', privacy: 'Politika zasebnosti' },
  },
}

export default TRANSLATION
